import Layout from '../component/Layout/Layout'
import ComponentStoreGallery from '../pages/ComponentStoreGallery'
import ComponentStoreGalleryDubai from '../pages/ComponentStoreGalleryDubai'
import ComponentMaansiKetan from './ComponentMaansiKetan'
import ComponentPeopleOfChaashni from './ComponentPeopleOfChaashni'
import { useNewHomeAPI } from "../hooks/useAllCategoryData";
import { useEffect } from 'react'

const scrollToHash = () => {
  const hash = window.location.hash;
  if (!hash) return;

  const id = hash.substring(1);

  const tryScroll = (attemptsLeft = 10) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else if (attemptsLeft > 0) {
      setTimeout(() => tryScroll(attemptsLeft - 1), 300); // retry after 300ms
    }
  };

  tryScroll();
};


export default function NewAboutChaashni() {
 const { isLoading, error, data } = useNewHomeAPI();
 useEffect(() => {
  if (!isLoading && data) {
    // Wait for DOM to render before trying to scroll
    const timeout = setTimeout(() => {
      scrollToHash();
    }, 1200); // delay scroll slightly

    return () => clearTimeout(timeout);
  }
}, [isLoading, data]);
  if (error) return <div>{error.message}</div>;
  return (
    <Layout title="ABOUT MAANSI & KETAN : Chaashni Couture" description="Chaashni Couture: About Chaashni Couture" > 
        
    <div className='about-section'>
      <span className='scroll-sapn' id='maansiketan'></span>
      <ComponentMaansiKetan />
    </div>

    <div className='about-section static-page world-of-chaashni' >
      <span className='scroll-sapn' id='video'></span>
      <h1 className="sustom-heading-h1">The World of Chaashni</h1>
      {data?.theworldvideos && (
          <div className="container video-top-fluid">
            <div className="row justify-content-center"> 
              {data.theworldvideos.map((src, index) => (            
              <div className="col-md-3" key={index}>
                <video
                  controls                 
                  playsInline
                  webkitPlaysInline
                  className="video-playing"
                  preload="auto"
                  poster={`${process.env.REACT_APP_IMAGE_URL}home/showroom/${src.poster}`}>
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/showroom/${src.video}`} type="video/mp4" />
                </video>
                {/* <span>Behind the Seams</span> */}
              </div>))}                          
            </div>
          </div>
      )}      
    </div>

    <div className='about-section'>
      <span className='scroll-sapn' id='peopleofchaashni'></span>
      <ComponentPeopleOfChaashni />
    </div>

     <div className='about-section'>
      <span className='scroll-sapn' id='the-experience-center-new-delhi'></span>
      <ComponentStoreGallery />
    </div>

    <div className='about-section' style={{paddingBottom:'0'}}>
      <span className='scroll-sapn' id='the-gulf-flagship-dubai'></span>
      <ComponentStoreGalleryDubai />
    </div>
    

    </Layout>
  )
}